class EnumType {
    constructor(public value: string) {}
}

export {EnumType};
